export enum ReportLayoutType {
    flexmonster = 'Flexmonster',
    organigram = 'Organigram',
    kpi = 'Kpi',
    kpiHeader = 'KpiHeader'
}
